var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip-notes"},_vm._l((_vm.notes),function(note,index){return _c('p',{key:index,staticClass:"tooltip-note"},[_vm._v(_vm._s(note.body.trim())+" "+_vm._s(_vm.metaData(note)))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }